<script lang="ts">
	interface Props {
		className?: string;
		hexColor?: string;
	}

	let { className = '', hexColor = 'currentColor' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={hexColor}>
		<circle cx="12" cy="12" r="12" fill="currentColor"></circle>
	</svg>
</div>
